
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import PanelFrame from '@/components/molecules/PanelFrame.vue'
import TextSearch from '@/components/molecules/TextSearch.vue'
import ButtonDownload from '@/components/molecules/ButtonDownload.vue'
import ButtonUpload from '@/components/molecules/ButtonUpload.vue'
import RoundSelect from '@/components/molecules/RoundSelect.vue'
import UserListTable from '@/components/organisms/manage/UserListTable.vue'
import PageLinkButton from '@/components/organisms/PageLinkButton.vue'
import { UserList } from '@/models/manage/UserList'
import { SelectItem } from '@/models/SelectItem'

/**
 * ユーザ一覧パネル
 */
@Component({
  components: {
    PanelFrame,
    TextSearch,
    ButtonDownload,
    ButtonUpload,
    RoundSelect,
    UserListTable,
    PageLinkButton,
  },
})
export default class UserListPanel extends Vue {
  /** 塾フィルター */
  @Ref()
  academyFilter!: RoundSelect

  /** 教室フィルター */
  @Ref()
  branchFilter!: RoundSelect

  /** 検索欄 */
  @Ref()
  textSearch!: TextSearch

  /** ユーザ一覧テーブル */
  @Ref()
  userListTable!: UserListTable

  /** ユーザ一覧 */
  @Prop()
  private userList!: UserList[]

  /** 塾フィルターの選択肢 */
  @Prop()
  private filterAcademyList?: SelectItem[]

  /** 教室フィルターの選択肢 */
  @Prop()
  private filterBranchList?: SelectItem[]

  /** ページ数 */
  @Prop()
  private pageLength!: number

  /** 現在のページ */
  @Prop()
  private currentPage!: number

  /** フィルター変更時のイベント */
  @Prop()
  private changeFilter!: () => void

  /** 検索ボタン押下時の処理 */
  @Prop()
  private eventClickSearch!: () => void

  /** 編集エリア表示イベント */
  @Prop()
  private eventClickEditButton!: (event: Event, userId: number) => Promise<void>

  /** ページリンクボタン押下時のイベント */
  @Prop()
  private changePage!: (value: number) => void

  /**
   * 検索文字列
   *
   * @returns 入力された文字列
   */
  public textInputed(): string {
    return this.textSearch.text
  }

  /**
   * 選択中の塾
   *
   * @returns 塾コード
   */
  public currentAcademy(): string | null {
    if (!this.academyFilter) {
      return null
    }
    return this.academyFilter.selectedValue()
  }

  /**
   * 塾フィルターの選択値を設定
   *   選択肢の変更時にselectの値を直接書き換える
   *
   * @param value 選択値指定
   */
  public setCurrentAcademy(value: string): void {
    this.academyFilter.setCurrentValue(value)
  }

  /**
   * 選択中の教室
   *
   * @returns 教室コード
   */
  public currentBranch(): string | null {
    if (!this.branchFilter) {
      return null
    }
    return this.branchFilter.selectedValue()
  }

  /**
   * 教室フィルターの選択値を設定
   *   選択肢の変更時にselectの値を直接書き換える
   *
   * @param value 選択値指定
   */
  public setCurrentBranch(value: string): void {
    this.branchFilter.setCurrentValue(value)
  }
}
